import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
	InfoTokenService,
	IPermissions,
	IPkSk,
	IRole,
	IRosources,
	Modules,
	RolesUserService,
} from '@mangosoft/mango-layout';
import { ConfigService, DataLoginService } from '@mangosoft/mango-login';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LoadingService } from './Infrastructure/Services/loading.service';
import { environment } from '../environments/environment';
import { modulesSidebar } from './modulesMango';

declare var require: any;
const version = require('../../../../package.json').version;
const url = environment.apiUrl;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterContentChecked {
	version: string = '';
	url = '';
	mode = 'desktop-close';
	stateAuth: boolean = false;
	viewNotifications = false;
	subscriptionRoute!: Subscription;
	ids!: IPkSk;

	listSidebar: Modules[] = [];
	loading: boolean = false;
	constructor(
		private serviceDataLogin: DataLoginService,
		private roleUserService: RolesUserService,
		private infoUser: InfoTokenService,
		
		private changeDetector: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.ids = environment.ids;
		this.configDataCore();
		this.validateRoles();
	}
	ngAfterContentChecked(): void {
		this.changeDetector.detectChanges();
	}

	configDataCore() {
		// this.configService
		// .config(url, environment.ids, environment.secretKey)
		// .then((response) => {
		//   this.loading = false;
		// });
		this.version = version;
		this.url = url;
		// this.configService.config(url, environment.secretKey).then(() => {});
		this.serviceDataLogin.saveData({
			version: this.version,
			url: this.url,
			route: 'users',
		});
	}

	validateRoles() {
		this.roleUserService.getPermissions.subscribe((resp: IPermissions) => {
			let roles: IRole[] = [];
			this.listSidebar = [];
			if (resp?.permissions) {
				resp.permissions.forEach((permissions) => {
					if (permissions.host === location.hostname) {
						roles = permissions.roles;
					}
				});
				let allResources: IRosources[] = [];
				roles.forEach((role) => {
					allResources.push(...role.resources);
				});
				const isSystemModules = allResources.some(
					(resource) =>
						resource.path.toLowerCase().includes('system-modules') &&
						resource.action.toLowerCase().includes('post')
				);
				const isClients = allResources.some(
					(resource) =>
						resource.path.toLowerCase().includes('clients') &&
						resource.action.toLowerCase().includes('post')
				);
				const isRoles = allResources.some(
					(resource) =>
						resource.path.toLowerCase().includes('roles') &&
						resource.action.toLowerCase().includes('post')
				);
				const isUsers = allResources.some(
					(resource) =>
						resource.path.toLowerCase().includes('users') &&
						resource.action.toLowerCase().includes('post')
				);
				const isGroups = allResources.some(
					(resource) =>
						resource.path.toLowerCase().includes('groups') &&
						resource.action.toLowerCase().includes('post')
				);
				const isAdmin = this.infoUser.getUserData()?.username?.toLowerCase() === 'administrador';

				if (isSystemModules || isAdmin) {
					this.listSidebar.push(modulesSidebar[0]);
				}
				if (isClients || isAdmin) {
					this.listSidebar.push(modulesSidebar[1]);
				}
				if (isRoles || isAdmin) {
					this.listSidebar.push(modulesSidebar[2]);
				}
				if (isUsers || isAdmin) {
					this.listSidebar.push(modulesSidebar[3]);
				}
				if (isGroups || isAdmin) {
					this.listSidebar.push(modulesSidebar[4]);
				}
				this.listSidebar = [...this.listSidebar];
			}
		});
	}
}
